export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  isHot: boolean;
  isNew: boolean;
}

export const movies: Movie[] = [
  {
    id: "movie-1",
    title: "流浪地球3",
    englishTitle: "The Wandering Earth III",
    year: 2026,
    category: "科幻",
    categorySlug: "scifi",
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20futuristic%20space%20station%20with%20massive%20engines%20glowing%20warm%20orange%20and%20gold%2C%20Earth%20visible%20in%20background%2C%20dark%20cosmic%20background%2C%20dramatic%20lighting%2C%20Chinese%20sci-fi%20film%20aesthetic%2C%20epic%20scale%2C%20professional%20movie%20poster%20composition%2C%20warm%20tone%20highlights%20on%20metallic%20surfaces&width=800&height=1200&seq=movie-wandering-earth-3&orientation=portrait",
    description: "太阳急速老化，持续膨胀，地球面临被吞没的危机。人类再次启动行星发动机，踏上寻找新家园的旅程。这一次，他们将面对前所未有的挑战与未知。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢"],
    duration: "148分钟",
    isHot: true,
    isNew: true,
  },
  {
    id: "movie-2",
    title: "封神第二部",
    englishTitle: "Creation of the Gods II",
    year: 2025,
    category: "动作",
    categorySlug: "action",
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20movie%20poster%2C%20ancient%20warriors%20in%20ornate%20armor%20with%20warm%20golden%20and%20crimson%20tones%2C%20mythical%20creatures%20silhouetted%20against%20a%20dramatic%20sunset%20sky%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20cinematic%20quality%2C%20professional%20film%20poster%20design%2C%20warm%20atmospheric%20lighting&width=800&height=1200&seq=movie-fengshen-2&orientation=portrait",
    description: "殷商大军压境，西岐军民奋起抵抗。姜子牙率领众神与凡人，展开了一场关乎天下苍生的史诗大战。神话与历史的交织，英雄与命运的碰撞。",
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤", "于适"],
    duration: "156分钟",
    isHot: true,
    isNew: true,
  },
  {
    id: "movie-3",
    title: "哪吒之魔童闹海",
    englishTitle: "Nezha: The Devil's Wrath",
    year: 2025,
    category: "动画",
    categorySlug: "animation",
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20mythological%20boy%20with%20flaming%20wheels%20and%20red%20ribbon%20flying%20over%20turbulent%20ocean%2C%20dramatic%20stormy%20sky%20with%20warm%20golden%20light%20breaking%20through%2C%20vibrant%20warm%20colors%2C%20traditional%20Chinese%20painting%20influence%2C%20cinematic%20quality%2C%20epic%20scale&width=800&height=1200&seq=movie-nezha-2&orientation=portrait",
    description: "天劫之后，哪吒和敖丙的灵魂虽保住，但肉身面临消散的危险。太乙真人试图用七色宝莲为他们重塑肉身，然而在这个过程中却遭遇了重重困难与挑战。",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "陈浩"],
    duration: "110分钟",
    isHot: true,
    isNew: false,
  },
  {
    id: "movie-4",
    title: "红海行动2",
    englishTitle: "Operation Red Sea II",
    year: 2025,
    category: "动作",
    categorySlug: "action",
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Military%20action%20movie%20poster%2C%20elite%20soldiers%20in%20tactical%20gear%20on%20a%20warship%20deck%2C%20dramatic%20ocean%20sunset%20with%20warm%20golden%20and%20amber%20sky%2C%20helicopters%20in%20distance%2C%20professional%20cinematic%20composition%2C%20intense%20atmosphere%2C%20warm%20color%20grading&width=800&height=1200&seq=movie-red-sea-2&orientation=portrait",
    description: "蛟龙突击队再次出征，深入战火纷飞的地区执行危险营救任务。面对重重包围，他们用血肉之躯筑起钢铁长城，展现中国军人的无畏精神。",
    director: "林超贤",
    actors: ["张译", "黄景瑜", "海清", "杜江"],
    duration: "142分钟",
    isHot: true,
    isNew: false,
  },
  {
    id: "movie-5",
    title: "人生大事",
    englishTitle: "Lighting Up The Stars",
    year: 2024,
    category: "喜剧",
    categorySlug: "comedy",
    rating: 8.3,
    image: "https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20comedy-drama%20movie%20poster%2C%20a%20man%20and%20a%20little%20girl%20walking%20on%20a%20narrow%20old%20street%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20urban%20Chinese%20neighborhood%2C%20tender%20emotional%20atmosphere%2C%20soft%20warm%20tones%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-life-event&orientation=portrait",
    description: "殡葬师莫三妹遇到了孤儿武小文，两个看似毫不相干的人，却在一系列啼笑皆非的故事中，重新找到了生活的意义和温暖。",
    director: "刘江江",
    actors: ["朱一龙", "杨恩又", "王戈"],
    duration: "112分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-6",
    title: "深海",
    englishTitle: "Deep Sea",
    year: 2024,
    category: "动画",
    categorySlug: "animation",
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Artistic%20Chinese%20animated%20movie%20poster%2C%20a%20young%20girl%20submerged%20in%20deep%20ocean%20surrounded%20by%20colorful%20bioluminescent%20jellyfish%20and%20coral%2C%20dreamlike%20underwater%20world%2C%20warm%20and%20vibrant%20colors%2C%20ink%20wash%20painting%20style%20mixed%20with%203D%2C%20fantastical%20atmosphere&width=800&height=1200&seq=movie-deep-sea&orientation=portrait",
    description: "一个现代少女误入梦幻的深海世界，邂逅了一段独特的生命旅程。在这个色彩斑斓的水下世界中，她逐渐找到了内心深处的勇气与力量。",
    director: "田晓鹏",
    actors: ["苏鑫", "王亭文", "滕奎兴"],
    duration: "112分钟",
    isHot: false,
    isNew: true,
  },
  {
    id: "movie-7",
    title: "唐人街探案4",
    englishTitle: "Detective Chinatown IV",
    year: 2025,
    category: "喜剧",
    categorySlug: "comedy",
    rating: 8.1,
    image: "https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%2C%20two%20detectives%20in%20colorful%20outfits%20standing%20in%20front%20of%20bright%20neon-lit%20Chinatown%20street%20at%20night%2C%20warm%20red%20and%20gold%20lanterns%2C%20playful%20vibe%2C%20cinematic%20composition%2C%20professional%20poster%20design&width=800&height=1200&seq=movie-chinatown-4&orientation=portrait",
    description: "唐仁和秦风这对完美搭档再度联手，这次他们来到伦敦，卷入了一桩离奇的国际大案。在异国他乡，他们需要凭借智慧和勇气解开层层谜题。",
    director: "陈思诚",
    actors: ["王宝强", "刘昊然", "妻夫木聪"],
    duration: "135分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-8",
    title: "消失的她",
    englishTitle: "Lost in the Stars",
    year: 2024,
    category: "悬疑",
    categorySlug: "suspense",
    rating: 8.4,
    image: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20a%20woman%20silhouette%20disappearing%20into%20darkness%20with%20faint%20warm%20golden%20light%20edges%2C%20tropical%20island%20silhouette%20in%20background%2C%20ominous%20yet%20elegant%20atmosphere%2C%20minimalist%20design%2C%20high%20contrast%2C%20professional%20film%20poster&width=800&height=1200&seq=movie-lost-stars&orientation=portrait",
    description: "何非的妻子在海外旅行时神秘失踪，当他报案时，一个陌生女人出现了，声称自己就是他的妻子。真相与谎言交织，一场心理博弈就此展开。",
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊"],
    duration: "122分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-9",
    title: "独行月球",
    englishTitle: "Moon Man",
    year: 2024,
    category: "科幻",
    categorySlug: "scifi",
    rating: 8.2,
    image: "https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20movie%20poster%2C%20a%20lone%20astronaut%20standing%20on%20the%20moon%20surface%20with%20Earth%20in%20the%20background%2C%20warm%20golden%20sunlight%20on%20the%20lunar%20surface%2C%20humorous%20pose%2C%20stunning%20space%20backdrop%2C%20cinematic%20quality%2C%20warm%20color%20palette&width=800&height=1200&seq=movie-moon-man&orientation=portrait",
    description: "人类为阻止小行星撞击地球，部署了月盾计划。维修工独孤月因意外错过撤离，被遗留在了月球上。他成了宇宙最后的人类，开始了破罐子破摔的月球生活。",
    director: "张吃鱼",
    actors: ["沈腾", "马丽", "黄才伦"],
    duration: "122分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-10",
    title: "长津湖之水门桥",
    englishTitle: "The Battle at Lake Changjin II",
    year: 2024,
    category: "动作",
    categorySlug: "action",
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=War%20movie%20poster%2C%20soldiers%20in%20winter%20battle%20gear%20advancing%20through%20snow%20and%20ice%2C%20dramatic%20warm%20sunset%20light%20breaking%20through%20smoke%2C%20epic%20battlefield%20scene%2C%20heroic%20composition%2C%20cinematic%20quality%2C%20golden%20hour%20lighting%20on%20snow&width=800&height=1200&seq=movie-water-gate&orientation=portrait",
    description: "在极度严寒的环境下，志愿军战士们以钢铁般的意志，在水门桥与敌军展开了一场惊心动魄的生死较量。他们用血肉之躯筑起了保家卫国的坚固防线。",
    director: "陈凯歌",
    actors: ["吴京", "易烊千玺", "朱亚文"],
    duration: "149分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-11",
    title: "你好，李焕英",
    englishTitle: "Hi, Mom",
    year: 2023,
    category: "喜剧",
    categorySlug: "comedy",
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20comedy%20movie%20poster%2C%20mother%20and%20daughter%20hugging%20in%20a%20nostalgic%201980s%20Chinese%20factory%20setting%2C%20warm%20golden%20sunset%20light%2C%20retro%20aesthetic%2C%20emotional%20tender%20atmosphere%2C%20soft%20focus%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-hi-mom&orientation=portrait",
    description: "贾晓玲意外穿越回到1981年，与年轻时的母亲李焕英相遇。她决定用自己的一切来让母亲过上更好的生活，却在这过程中发现了母爱的真正含义。",
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾"],
    duration: "128分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "movie-12",
    title: "无名",
    englishTitle: "Hidden Blade",
    year: 2024,
    category: "悬疑",
    categorySlug: "suspense",
    rating: 8.0,
    image: "https://readdy.ai/api/search-image?query=Spy%20thriller%20movie%20poster%2C%20elegant%20man%20in%201940s%20Shanghai%20suit%20standing%20in%20shadow%2C%20warm%20vintage%20lighting%2C%20art%20deco%20interior%2C%20mysterious%20atmosphere%2C%20film%20noir%20aesthetic%2C%20golden%20amber%20highlights%2C%20professional%20cinematic%20poster&width=800&height=1200&seq=movie-hidden-blade&orientation=portrait",
    description: "上世纪三四十年代，一群无名英雄潜伏在敌人心脏地带，用智慧和勇气传递情报。在波诡云谲的上海滩，每一个选择都可能关乎生死。",
    director: "程耳",
    actors: ["梁朝伟", "王一博", "周迅"],
    duration: "128分钟",
    isHot: false,
    isNew: false,
  },
];

export const categories = [
  { name: "全部", slug: "all" },
  { name: "动作", slug: "action" },
  { name: "喜剧", slug: "comedy" },
  { name: "科幻", slug: "scifi" },
  { name: "悬疑", slug: "suspense" },
  { name: "动画", slug: "animation" },
];

export const hotMovies = movies.filter((m) => m.isHot);
export const newMovies = movies.filter((m) => m.isNew);
export const topRatedMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);